import { z } from 'zod/v4'

import { WorkspacePermissionsValidator, WorkspaceRoleValidator } from './WorkspaceTypes'

export const UserValidator = z.object({
	id: z.number(),
	uuid: z.string(),
	first_name: z.string().nullable(),
	last_name: z.string().nullable(),
	email: z.string(),
	created_date: z.iso.datetime().nullable(),
})

export const WorkspaceMemberValidator = z.object({
	user_id: UserValidator.shape.uuid.nullable(),
	role: WorkspaceRoleValidator,
	joined_at: z.iso.datetime(),
	email: UserValidator.shape.email,
	invitation_status: WorkspacePermissionsValidator.shape.invitation_status,
	first_name: UserValidator.shape.first_name,
	last_name: UserValidator.shape.last_name,
})

export type User = z.infer<typeof UserValidator>
export type WorkspaceMember = z.infer<typeof WorkspaceMemberValidator>
